import InfoCard from "../../components/info-card";
import { RoutePaths } from "../../models";
import ContentElement from "./contentElement";
import { InfoCardType } from "./types";
import { getInfoCardVariantByDelta } from "./utils";

interface InfoCardListProps {
  infoCards: InfoCardType[];
  onCardClick?: (routePath?: RoutePaths) => void;
}

export default function InfoCardList({
  infoCards,
  onCardClick,
}: InfoCardListProps) {
  return (
    <div className="row d-flex align-items-center mt-4">
      {infoCards.map((infoCard, index) => {
        const isSummaryInfoCard = infoCard.type === "SUMMARY";
        return (
          <div key={index} className="col-lg-4 my-4 mt-lg-0">
            <InfoCard
              variant={getInfoCardVariantByDelta(
                isSummaryInfoCard ? infoCard.delta.type : undefined
              )}
              label={infoCard.label}
              content={
                <ContentElement
                  content={infoCard.content}
                  delta={isSummaryInfoCard ? infoCard.delta : undefined}
                />
              }
              onClick={
                isSummaryInfoCard
                  ? () => onCardClick?.(infoCard.navigateTo)
                  : undefined
              }
            />
          </div>
        );
      })}
    </div>
  );
}
